<template>
  <el-dialog :title="title" :class="className" :width="width" :visible.sync="dialogVisible" @closed="closed">
    <slot></slot>
  </el-dialog>
</template>

<script>
export default {
  name: "Dialog",
  props: {
    title: String,
    className: String,
    width: String
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    show() {
      this.dialogVisible = true
    },
    hide() {
      this.dialogVisible = false
    },
    closed() {
      this.$emit('closed')
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  .el-dialog__header {
    padding: 15px 20px;

    .el-dialog__title {
      color: #606266;
    }
  }
}
</style>
